<template>
    <div class="table-action-buttons">
        <i v-if="$hasRole('super_admin') && isSkipped && data.action_progress_status_id != 4" class="fa fa-step-backward fa-lg pointer"
                @click="undoSkip" :title="uLang('app.unskip_action_progress')"></i>
        <i v-if="$hasRole('super_admin') && !isSkipped && data.action_progress_status_id != 4" class="fa fa-step-forward fa-lg pointer"
           @click="skip" :title="uLang('app.skip_action_progress')"></i>
        <!--// id ==4  > commpleted-->
        <i
            v-if="$hasRole('super_admin') && !isSkipped && data.action_progress_status_id == 4"
            class="fa fa-fax fa-lg pointer"
            @click="invoiceAction"
            :title="uLang('app.retry_invoicing')"
        ></i>
    </div>
</template>

<script>
    import {SuccessAlert, ConfirmationAlert, ErrorAlert} from '~/Swals';

    export default {
        name: 'actions',
        props: ['data', 'index'],

        methods: {
            invoiceAction() {
                new ConfirmationAlert({text: this.uLang('app.invoice_action_again')})
                    .show()
                    .then(async () => {
                        this.commitInvoiceAction()
                    });
            },

            commitInvoiceAction() {
                window.axios.post(
                    route('invoices.create_from_action'),
                    { action_progress_id: this.data.id }
                ).then(() => {
                    new SuccessAlert({
                        title: uLang('app.action_progress'),
                        text: this.uLang('app.action_progress_invoiced')
                    }).show();

                    vue.$emit('reloadTable');
                }).catch(({response}) => {
                    this.handleError(response);
                })
            },

            skip() {
                new ConfirmationAlert({text: this.uLang('app.skip_action_progress_question')})
                .show()
                .then(async () => {
                    this.commitSkip()
                });
            },

            undoSkip() {
                new ConfirmationAlert({text: this.uLang('app.unskip_action_progress_question')})
                .show()
                .then(async () => {
                    this.commitUndoSkip()
                });
            },

            async commitSkip() {
                window.axios.put(
                    route('relations.trajectory-enrolments.milestone-progresses.action-progress.skip', {
                        action_progress: this.data.id,
                    }),
                    {}
                ).then(() => {
                    new SuccessAlert({
                        title: uLang('app.action_progress'),
                        text: this.uLang('app.action_progress_skipped')
                    }).show();
                    vue.$emit('reloadTable');
                }).catch(({response}) => {
                    this.handleError(response);
                })
            },

            async commitUndoSkip() {
                window.axios.put(
                    route('relations.trajectory-enrolments.milestone-progresses.action-progress.undo_skip', {
                        action_progress: this.data.id,
                    }),
                    {}
                ).then(() => {
                    new SuccessAlert({
                        title: uLang('app.action_progress'),
                        text: this.uLang('app.action_progress_unskipped')
                    }).show();
                    vue.$emit('reloadTable');
                }).catch(({response}) => {
                    this.handleError(response)
                })
            },

            handleError(response) {
                if (response.status === 403) {
                    response.data.message = 'U heeft geen rechten voor deze actie op dit traject.';
                }

                new ErrorAlert({
                    text: response.data.message
                }).show();
            }
        },
        computed: {
            isSkipped() {
                return this.data.action_progress_status.name === 'skipped'
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>
